export default "__VITE_ASSET__B$B7octD__"